import { render, staticRenderFns } from "./biaozhu.vue?vue&type=template&id=4d9e98a0&scoped=true"
import script from "./biaozhu.vue?vue&type=script&lang=js"
export * from "./biaozhu.vue?vue&type=script&lang=js"
import style0 from "./biaozhu.vue?vue&type=style&index=0&id=4d9e98a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9e98a0",
  null
  
)

export default component.exports